<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    Edit Profile
                </div>
                <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="firstName">First Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span  class="form-control" >{{firstName}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="lastName">Last Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span  class="form-control" >{{lastName}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="email">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span  class="form-control" >{{email}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="username">Day Force Id :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span v-model="username" class="form-control">{{username}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span v-model="locationId" class="form-control">{{locationId}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="phone">Phone :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span  class="form-control" >{{phone}}</span>
                                </div>
                            </div>
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="post">Post :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="post" type="text" class="form-control" id="post" placeholder="Post">
                                    <font class="text-danger">{{frontendErrors.postError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="teamdesignation">Team Designation :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="teamDesignation" type="text" class="form-control" id="teamDesignation" placeholder="Team Designation">
                                    <font class="text-danger">{{frontendErrors.teamDesignationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="bio">Bio :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="bio" type="text" class="form-control" id="bio" placeholder="Bio">
                                </div>
                            </div>-->
                            <div v-if="loginId != user_id" class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Role :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select class=""
                                              v-model="roleId"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="roleArr"
                                              placeholder="Select Role">
                                    </v-select>
                                </div>
                            </div>
                            <!--<div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" ></tinymce>
                                    <font class="text-danger">{{frontendErrors.descriptionError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="quote">Quote :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="quote" type="text" class="form-control" id="quote" placeholder="Quote">
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="quoteName">Quote Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="quoteName" type="text" class="form-control" id="quoteName" placeholder="Quote Name">
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" >Profile Picture :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-error="fileError"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <font class="text-danger"> <strong id="uploadErrorMsg" class="error text-danger"></strong></font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-12 form-input-control paddingleft0">
                                    <vue-croppie
                                    ref="croppieRef"
                                    id="vuecrop"
                                    :viewport="{width:276, height: 312, type: 'square'}"
                                    :boundary="{ width: 286, height: 322 }"
                                    :enableResize="false"
                                    @result="result"
                                    @update="update" ></vue-croppie>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-12 form-input-control paddingleft0">
                                    <button class="btn-croppie" id="rotateAnti" type="button" @click="rotate(-90)" title="Rotate Left"><i aria-hidden="true" class="fa fa-repeat"></i></button>
                                    <button class="btn-croppie" id="rotateClock" type="button" @click="rotate(90)" title="Rotate Right"><i aria-hidden="true" class="fa fa-undo"></i></button>
                                    <button class="btn-croppie" id="crop" type="button" @click="crop()" title="Crop"><i class="fa fa-crop" aria-hidden="true"></i></button>
                                    <br/>
                                    <img v-bind:src="cropped" width="200"/>
                                    <font class="text-danger">{{cropError}}</font>
                                    <button @click="bind()">Bind</button>
                                </div>
                            </div>-->
                            <div class="col-12 ">
                                <div class="col-12 paddingleft0">
                                    <input type="submit" value="Save" id="save" class="btn general-button btn-primary" v-on:click.prevent="changeProfile()">
                                    <input type="button" value="Change Password" id="change_password" data-toggle="modal" class="btn general-button btn-primary" data-target="#changePassword" >
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Model-->
                    <div class="modal fade" id="changePassword" role="dialog">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Change Password</h4>
                                    <button type="button" id="changePasswordModel" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <!--Old Password-->
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="oldPassword">Old Password</label>
                                            <input class="form-control" id="oldPassword" type="text" placeholder="" name="oldPassword"  v-model="oldPassword">
                                            <font class="text-danger">{{frontendErrors.oldPassword}}</font>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <!--New Password-->
                                    <div class="col-md-12">
                                        <div class="form-group">    <label for="newPassword">New Password</label>
                                            <input class="form-control" id="newPassword" type="text" placeholder="" name="newPassword"  v-model="newPassword">
                                            <font class="text-danger">{{frontendErrors.newPassword}}</font>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <!--Confirm Password-->
                                    <div class="col-md-12">
                                        <div class="form-group">    <label for="cpassword">Confirm Password</label>
                                            <input class="form-control" id="cpassword" type="text" placeholder="" name="cpassword"  v-model="cpassword">
                                            <font class="text-danger">{{frontendErrors.cpassword}}</font>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <!--Error Alert-->
                                    <div class="row clearfix" >
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="alert alert-danger" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button v-on:click.prevent="changePassword()" class="btn btn-primary">Save</button>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--page content-->
                    <app-footer></app-footer>
                </form>
            </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Footer from "@/components/partials/Footer";
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import EventBus from '../../event-bus';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    // Remove package i.e: "vue-croppie": "^2.0.1" as not in used (BS-10/01/2024)
    // import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    
    // Remove package i.e: "vue-tinymce-editor": "1.6.2", as not in used (BS-10/01/2024)
    // import tinymce from 'vue-tinymce-editor';
    import axios from 'axios';

    // Vue.use(VueCroppie);
    export default {
        name: 'changeProfile',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            // 'tinymce': tinymce,
            'app-footer': Footer,
        },
        data() {
            return {
                //DropZone
                dropzoneOptions: {
//                    url: "https://httpbin.org/post",
                    url: process.env.VUE_APP_ROOT_API + "/uploadmedia",
                    timeout: 3000000,
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 8, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is to big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imageURL: '',
                isDropFileUploaded: false,
                filePath: '',
//                V-model
                firstName: '',
                lastName: '',
                oldPassword: '',
                newPassword: '',
                cpassword: '',
                user_id: '',
                locationId: '',
                locationArr: [],
                phone: '',
                description: '',
                bio: '',
                quote: '',
                quoteName: '',
                email: '',
                username: '',
                locationData: '',
                locationArr: [],
                locationIdSearch: '',
                post: '',
                teamDesignation: '',
                imageSize: '',
                id: '',

                cropped: null,
                profileImages: [],
                croppedProfileImage: '',
                isCropped: false,
                isFileUploaded: false,
                cropError: '',
                loginId: '',
                roleId: 0,
                roleArr: [],

//                FrontEnd Errors
                frontendErrors: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    oldPassword: '',
                    newPassword: '',
                    cpassword: '',
                    locationError: '',
                    phoneError: '',
                    descriptionError: '',
                    postError: '',
                    teamDesignationError: '',
                },

//                BackEnd Error
                backendErrors: [],
                error: '',
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;
            self.loadLocations();
            self.loadProfile();
            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/
            $("#firstName").on('keyup', function () {
                self.frontendErrors.firstName = '';
            });
            $("#lastName").on('keyup', function () {
                self.frontendErrors.lastName = '';
            });
            $("#phone").on('keyup', function () {
                self.frontendErrors.phoneError = '';
            });
            $("#oldPassword").on('keyup', function () {
                self.frontendErrors.oldPassword = '';
            });
            $("#newPassword").on('keyup', function () {
                self.frontendErrors.newPassword = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            $("#password").on('keyup', function () {
                self.frontendErrors.password = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            $("#post").on('keyup', function () {
                self.frontendErrors.postError = '';
            });
            $("#teamDesignation").on('keyup', function () {
                self.frontendErrors.teamDesignationError = '';
            });
            $("#email").on('keyup', function () {
                self.frontendErrors.email = '';
            });
            self.loadLocations();

            $("#vuecrop").hide();
            $("#rotateAnti").hide();
            $("#rotateClock").hide();
            $("#crop").hide();

            /*self.$refs.croppieRef.bind({
             url: '',
             });*/

            $("#browse").on('change', function () {
                self.readFile(this);
                $("#vuecrop").show();
                $("#rotateAnti").show();
                $("#rotateClock").show();
                $("#crop").show();
            });
            self.loadRole();
        },
        watch: {

        },
        methods: {

            buttonBack() {
                self.$router.push('/backend/listusers');
            },
            removedSelectedFile(file, xhr, error) {
                self.isFileUploaded = false;
                self.isDropFileUploaded = false;
                self.isCropped = false;
                var filePath = JSON.parse(file.xhr.response);
                self.imageURL = '';
                self.imageSize = '';
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                $("#vuecrop").hide();
                $("#rotateAnti").hide();
                $("#rotateClock").hide();
                $("#crop").hide();
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
//                        console.log("File removed successfully");
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                self.cropError = '';
                console.log(file);
                $("#uploadErrorMsg").html('');
                if (self.isDropFileUploaded == false) {
                    self.imageURL = file.dataURL;
                    self.isDropFileUploaded = true;
                    self.isFileUploaded = true;
                    self.$refs.croppieRef.bind({
                        url: self.imageURL,
                    });
                    $("#vuecrop").show();
                    $("#rotateAnti").show();
                    $("#rotateClock").show();
                    $("#crop").show();
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.filePath = filePathJSON.content.media_path;
                    self.imageSize = file.size;
                } else if (self.isDropFileUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One Image";
                    $("#uploadErrorMsg").html(err);
                }
            },

            changedValue: function (value) {
                //console.log(value);
            },

            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.frontendErrors.locationError = "";
            },

            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadLocations() {
                HTTP.post("getstate")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            checkPasswordForm: function () {
                var checked = true;
                self.frontendErrors.oldPassword = '';
                self.frontendErrors.newPassword = '';
                self.frontendErrors.cpassword = '';

                if (!self.oldPassword) {
                    self.frontendErrors.oldPassword = 'Old Password Required';
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.newPassword) {
                    self.frontendErrors.newPassword = 'New Password Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.newPassword && self.newPassword.length < 6) {
                    self.frontendErrors.newPassword = "New Password Length Longer Than 6";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.newPassword != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            changePassword: function () {
                self.checkPasswordForm();
                if (self.checkPasswordForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                    };
                    var fields = {
                        oldPassword: self.oldPassword,
                        newPassword: self.newPassword,
                        confirmpassword: self.cpassword,
                    };
                    HTTP.post('changepassword', fields, config).then(function (response) {
                        if (response.data.code == '200') {
                            $("#changePasswordModel").click();
                            self.oldPassword = '';
                            self.newPassword = '';
                            self.cpassword = '';
                        } else {
                            $("#alertError").show();

                            if (response.data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < response.data.content.length; i++) {
                                    err += response.data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-danger").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-danger").removeClass("show");
                                    $(".alert-danger").addClass("hide");
                                }, 5000);
                            }
                        }

                    })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                }
                            })
                }

            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.firstName = "";
                self.frontendErrors.lastName = "";
                self.frontendErrors.locationError = "";
                self.frontendErrors.phoneError = "";
                /*self.cropError = "";*/
                self.frontendErrors.email = '';

                if (!self.email) {
                    self.frontendErrors.email = 'Please Enter Email';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.email)) {
                    self.frontendErrors.email = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.firstName) {
                    self.frontendErrors.firstName = "First Name Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastName) {
                    self.frontendErrors.lastName = "Last Name Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.locationId) {
                    self.frontendErrors.locationError = "State Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.phone && !String(self.phone).match(/^[0-9]*$/)) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Numeric.";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length < 10) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Of Minimum 10 Digits.";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phone && String(self.phone).match(/^[0-9]*$/) && self.phone.length > 13) {
                    self.frontendErrors.phoneError = "Phone Number Must Be Of Maximum 13 Digits.";
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (self.isFileUploaded == false) {
                 self.cropError = 'Please Upload Image';
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.isCropped == false) {
                 self.cropError = 'Please Crop the Image';
                 if (checked) {
                 checked = false;
                 }
                 }
                 if (!self.post) {
                 self.frontendErrors.postError = "Post Required.";
                 if (checked) {
                 checked = false;
                 }
                 }
                 if (!self.teamDesignation) {
                 self.frontendErrors.teamDesignationError = "Team Designation Required.";
                 if (checked) {
                 checked = false;
                 }
                 }*/

                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadProfile: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };

                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var userJson = JSON.parse(userObj);
                    self.loginId = userJson.id;
                    var fields = {id: "loginId"};
                }

//                if (segments[3] == 0) {
//                    var fields = {id: "loginId"};
//                } else {
//                    var fields = {id: segments[3]};
//                }

                HTTP.post('getregisteruser/' + self.loginId, fields, config)
                        //                HTTP.post("getregisteruser", '', config)
                        .then(function (response) {
//                        self.locationId = response.data.content[0].location_name;
                            self.user_id = response.data.content[0].id;
                            self.locationId = response.data.content[0].location_name;
                            self.firstName = response.data.content[0].first_name;
                            self.lastName = response.data.content[0].last_name;
                            self.description = response.data.content[0].description;
                            self.bio = response.data.content[0].bio;
                            self.quote = response.data.content[0].quote;
                            self.quoteName = response.data.content[0].quote_name;
                            self.email = response.data.content[0].email;
                            self.phone = response.data.content[0].phone;
                            self.username = response.data.content[0].username;
                            self.filePath = response.data.content[0].profile_image;
                            self.post = response.data.content[0].post;
                            self.teamDesignation = response.data.content[0].team_designation;
                            self.roleId = {
                                value: response.data.content[0].role_id,
                                text: response.data.content[0].role_name,
                            };
//                            self.cropped = response.data.content.profile_image;
                            //console.log(self.filePath);
                            if (!self.isFileUploaded) {
                                if (self.filePath != '') {
                                    self.isFileUploaded = true;
                                    self.isDropFileUploaded == true;
                                    self.imageSize = response.data.content[0].image_size;
                                    self.isCropped = true;
                                    self.uploadManually();
                                }
                            }
//                            if (self.cropped == '') {
//                                $("#crop").hide();
//                            } else if (self.cropped != '') {
//                                self.isFileUploaded = true;
//                                self.isCropped = true;
//                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            uploadManually(file) {
                if (self.filePath != '') {
                    var file_name = self.getFileName(self.filePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.filePath;
                    let file_size = self.imageSize;
                    //console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            changeProfile() {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");

                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        var userJson = JSON.parse(userObj);
                        self.id = userJson.id;
                    }

//                    if (segments[3] == 0) {
//                        self.id = self.loginId;
//                    } else {
//                        self.id = segments[3];
//                    }

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                    };
                    $("#save").val("Saving ...");
                    $("#save").prop("disabled", true);
                    var fields = {
                        id: self.id,
                        email: self.email,
                        first_name: self.firstName,
                        last_name: self.lastName,
                        phone: self.phone,
                        location_id: self.locationId.value,
                        description: self.description,
                        bio: self.bio,
                        quote: self.quote,
                        quote_name: self.quoteName,
                        profile_image: self.croppedProfileImage,
                        filePath: self.filePath,
                        imageSize: self.imageSize,
                        post: self.post,
                        team_designation: self.teamDesignation,
                        role_id: self.roleId.value,
                    };
                    HTTP.post("changeprofile", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.loadProfile()
                                    window.localStorage.setItem("profile_image", response.data.content.user_obj.profile_image);
                                    window.localStorage.setItem("user_obj", JSON.stringify(response.data.content.user_obj));
                                    window.localStorage.setItem("email", self.email);
                                    var userObj = localStorage.getItem("user_obj");
                                    if (userObj != null) {
                                        var userJson = JSON.parse(userObj);
                                        self.loginID = userJson.id;
                                        EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"], userJson["username"],localStorage.getItem("profile_image"));
                                    }
                                    $("#save").val("Save");
                                    $("#save").prop("disabled", false);
                                    self.$swal({
                                        type: 'success',
                                        text: 'Profile Changed Successfully',
                                        showConfirmButton: true,
                                    });
                                } else {
                                    $("#save").val("Save");
                                    $("#save").prop("disabled", false);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            })
                            .catch(function (err) {
                                $("#save").val("Save");
                                $("#save").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                            });
                }

                //
            }, /*,
             getUser() {
             var getUserdata = {
             'access_token': window.localStorage.getItem('access_token')
             };
             //var access_token = window.localStorage.getItem('access_token');
             axios.post(process.env.VUE_APP_ROOT_API + "/user", {
             headers: getUserdata
             })
             .then(function(resp) {
             self.flash(resp.data, 'success', {
             timeout: 3000
             });
             })
             .catch(function(resp) {
             console.log('getUser catch');
             console.log(resp);
             });
             }*/

            // CALBACK USAGE
            crop() {
                // Here we are getting the result via callback function
                // and set the result to this.cropped which is being
                // used to display the result above.
                self.isCropped = true;
                let options = {
                    format: 'jpeg',
                    circle: false,
                }
                self.$refs.croppieRef.result(options, (output) => {
                    self.cropped = output;
                    self.croppedProfileImage = self.cropped;
                    self.cropError = "";
                });
            },
            // EVENT USAGE
            result(output) {
                self.cropped = output;
            },
            update(val) {
                //console.log(val);
            },
            rotate(rotationAngle) {
                // Rotates the image
                self.$refs.croppieRef.rotate(rotationAngle);
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */

                // Generated and display file type custom error message using Dropzone event
                if(xhr.code === 415) {
                    this.$refs.dropzone.dropzone.emit("error", file, xhr.message);
                }
            },
        }

    }
    EventBus.$on('logged-in', function (isLogin, fname, lname, email,username, profile_image) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.firstName = fname;
            self.lastName = lname;
            self.email = email;
            self.profile_image = (profile_image != '') ? profile_image : '/static/images/default.jpg';
        }
    });
</script>

<style>
    /*.disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }*/
</style>
